module.exports = __webpack_public_path__ + "14dd5a2fc08f4ca7efed43aea6cfc8be.mp4";